import { useState } from 'react';
import { Text, Button, ButtonGroup } from '@chakra-ui/react';

import { Modal } from 'shared-components';

import { IArrivalStatus, ITravelStatus } from '../../../../types';

import { ArrivalStatusSelection } from './arrivalStatusDropdown';

import { AdditionalQuestions } from './additional-questions';
import { TravelStatusEnum } from 'api-paths-cas';

interface IProps {
  label: string;
  onClose: () => void;
  travelStatusSection: IArrivalStatus;
  onUpdate: (travelStatusSection: IArrivalStatus) => void;
}

export const EditArrivalStatus = (props: IProps) => {
  const { label, travelStatusSection } = props;
  const [arrivalStatus, setArrivalStatus] = useState<TravelStatusEnum | undefined>(travelStatusSection.status);

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [isEdited, setIsEdited] = useState<boolean>(false);
  const [additionalAnswers, setAdditionalAnswers] = useState<ITravelStatus>({});

  const submit = () => {
    props.onUpdate({ ...additionalAnswers, status: arrivalStatus });
    props.onClose();
  };

  return (
    <Modal
      id="edit-arrival-status"
      show={true}
      title={label}
      onClose={props.onClose}
      footer={
        <ButtonGroup size={'lg'} spacing={3}>
          <Button id="back-button" onClick={() => props.onClose()}>
            Back
          </Button>

          <Button id="submit-status-button" onClick={submit} isDisabled={!isComplete || !isEdited} variant={'solid'}>
            Update Status
          </Button>
        </ButtonGroup>
      }
    >
      <ArrivalStatusSelection
        setArrivalStatus={setArrivalStatus}
        arrivalStatus={arrivalStatus}
        setIsEdited={() => setIsEdited(true)}
      />

      <AdditionalQuestions
        setIsEdited={() => setIsEdited(true)}
        travelStatus={travelStatusSection}
        status={arrivalStatus}
        setComplete={setIsComplete}
        additionalAnswers={{
          answers: additionalAnswers,
          setAnswers: setAdditionalAnswers,
        }}
      />

      <Text>Note: This status is self-reported by the student. It may not reflect their true situation.</Text>

      <Text mb={0}>Manually changing this status does not move the student to a new stage.</Text>
    </Modal>
  );
};
